// extracted by mini-css-extract-plugin
export var active = "_vz-1";
export var circle = "_vz-0";
export var completed = "_vz-2";
export var connector = "_vz-4";
export var connectorCompleted = "_vz-7";
export var connectorSpacer = "_vz-5";
export var iconStrokeOverride = "_vz-8";
export var labelContainer = "_vz-6";
export var pending = "_vz-3";